module.exports = __webpack_public_path__ + "img/logo.cdd7e2db.png";